import { defineNuxtPlugin } from '#app'
import {
  flushClientEventLogQueue,
  initializeClientEventLog,
  reportWebOrderSuccess,
} from '@/utils/clientEventLog'

export default defineNuxtPlugin((nuxtApp) => {
  initializeClientEventLog(nuxtApp)

  return {
    provide: {
      clientEventLog: {
        flush: flushClientEventLogQueue,
        reportOrderSuccess: reportWebOrderSuccess,
      },
    },
  }
})
